import React from 'react';
import { TrendingUp, TrendingDown } from 'lucide-react';

interface MenuItemData {
  item: string;
  orders: number;
  revenue: number;
  margin?: number;
  avgPrice?: number;
  trend?: 'up' | 'down';
}

interface MenuPerformanceTableProps {
  data: MenuItemData[];
  loading?: boolean;
}

const MenuPerformanceTable: React.FC<MenuPerformanceTableProps> = ({ data, loading = false }) => {
  if (loading) {
    return (
      <div className="cc-menu-performance">
        {[1, 2, 3, 4, 5, 6].map((i) => (
          <div key={i} className="cc-loading-row">
            <div className="cc-loading-shimmer" style={{ width: '100%', height: 40, borderRadius: 8 }} />
          </div>
        ))}
      </div>
    );
  }

  if (!data || data.length === 0) {
    return (
      <div className="cc-menu-performance">
        <p className="cc-muted-text">No menu performance data available</p>
      </div>
    );
  }

  const getMarginColor = (margin: number): string => {
    if (margin >= 70) return '#10b981';
    if (margin >= 60) return '#f59e0b';
    return '#ef4444';
  };

  return (
    <div className="cc-menu-performance">
      {data.map((item, i) => (
        <div key={i} className="cc-menu-item-row">
          <div className="cc-menu-item-row__info">
            <div className="cc-menu-item-row__name">
              <span>{item.item}</span>
              {item.trend && (
                item.trend === 'up'
                  ? <TrendingUp size={10} color="#10b981" />
                  : <TrendingDown size={10} color="#ef4444" />
              )}
            </div>
            <div className="cc-menu-item-row__meta">
              {item.orders} orders
              {item.revenue > 0 && <> &middot; ${item.revenue.toLocaleString()} rev</>}
            </div>
          </div>
          {item.margin !== undefined && (
            <div className="cc-menu-item-row__margin">
              <div
                className="cc-menu-item-row__margin-value"
                style={{ color: getMarginColor(item.margin) }}
              >
                {item.margin}%
              </div>
              <div className="cc-menu-item-row__margin-label">margin</div>
            </div>
          )}
          {item.avgPrice !== undefined && (
            <div className="cc-menu-item-row__margin">
              <div className="cc-menu-item-row__margin-value" style={{ color: '#06b6d4' }}>
                ${item.avgPrice.toFixed(2)}
              </div>
              <div className="cc-menu-item-row__margin-label">avg price</div>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default MenuPerformanceTable;
